function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from "@apollo/client";
import { useNavigation, useNavigationState, useRoute } from "@react-navigation/native";
import { useRef } from "react";
import { graphql } from "@oui/lib/src/graphql/tada";
import { AuthScreenContainer } from "../components/AuthScreenContainer";
import { Button } from "../components/Button";
import { ErrorPresenter } from "../components/ErrorPresenter";
import { Link } from "../components/Link";
import { Text } from "../components/Text";
import { TextInput } from "../components/TextInput";
import { View } from "../components/View";
import { useForm } from "../hooks/useForm";
import { authClient } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { logEvent } from "../lib/log";
import Sentry from "../sentry";
import { useTheme } from "../styles";
var ResetPasswordMutation = graphql("\n  mutation ResetPassword($token: String!, $password: String!) {\n    updateOuiUserWithToken(value: $token, input: { password: $password }) {\n      username\n    }\n  }\n");
/**
 * Allows user to update their password given a valid API `Token`
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-145}
 */ export function ResetPassword() {
    var route = useRoute();
    var navigation = useNavigation();
    var theme = useTheme().theme;
    var _useMutation = _sliced_to_array(useMutation(ResetPasswordMutation), 2), resetPassword = _useMutation[0], error = _useMutation[1].error;
    var _useForm = useForm({
        password: '',
        passwordConfirmation: ''
    }), bind = _useForm.bind, data = _useForm.data, validate = _useForm.validate, humanErrors = _useForm.humanErrors;
    var hasLoginInHistory = useNavigationState(function(s) {
        return s.routes.find(function(r) {
            return r.name === 'Login';
        });
    });
    var passwordConfirmationInputRef = useRef(null);
    var $t = useI18n().$t;
    var request = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _route_params, _route_params_token;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!validate()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            authClient.signOut()
                        ];
                    case 1:
                        _state.sent();
                        logEvent('reset_password');
                        return [
                            2,
                            resetPassword({
                                variables: {
                                    password: data.password,
                                    token: (_route_params_token = (_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.token) !== null && _route_params_token !== void 0 ? _route_params_token : ''
                                }
                            }).then(function(result) {
                                var _result_data;
                                if ((_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.updateOuiUserWithToken) {
                                    if (hasLoginInHistory) {
                                        navigation.navigate('Login', {
                                            resetPassword: 'true'
                                        });
                                    } else {
                                        navigation.replace('Login', {
                                            resetPassword: 'true'
                                        });
                                    }
                                }
                            }).catch(function(e) {
                                Sentry.captureException(e);
                            })
                        ];
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function request() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(AuthScreenContainer, {
        heading: $t({
            id: 'ResetPassword_heading',
            defaultMessage: 'Choose a new password'
        }),
        children: /*#__PURE__*/ _jsxs(View, {
            spacing: 10,
            children: [
                Object.keys(humanErrors).length ? /*#__PURE__*/ _jsx(ErrorPresenter, {
                    formErrors: humanErrors
                }) : /*#__PURE__*/ _jsx(Text, {
                    text: $t({
                        id: 'ResetPassword_description',
                        defaultMessage: "You're almost there. Enter a new password to update your account."
                    }),
                    size: 16,
                    style: {
                        marginBottom: 20,
                        textAlign: 'center'
                    }
                }),
                /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({}, bind('password', {
                    label: $t({
                        id: 'ResetPassword_passwordLabel',
                        defaultMessage: 'New password'
                    }),
                    validator: [
                        {
                            type: 'present'
                        },
                        {
                            type: 'length',
                            minimum: 8
                        }
                    ]
                })), {
                    hint: $t({
                        id: 'ResetPassword_passwordHint',
                        defaultMessage: 'Must be at least 8 characters'
                    }),
                    secureTextEntry: true,
                    enterKeyHint: "done",
                    onSubmitEditing: function() {
                        var _passwordConfirmationInputRef_current;
                        (_passwordConfirmationInputRef_current = passwordConfirmationInputRef.current) === null || _passwordConfirmationInputRef_current === void 0 ? void 0 : _passwordConfirmationInputRef_current.focus();
                    },
                    autoComplete: "new-password",
                    testID: "ResetPassword_password"
                })),
                /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({}, bind('passwordConfirmation', {
                    label: $t({
                        id: 'ResetPassword_passwordConfirmationLabel',
                        defaultMessage: 'Confirm password'
                    }),
                    validator: [
                        function(val) {
                            if (data.password !== val) {
                                return $t({
                                    id: 'ResetPassword_passwordMismatchError',
                                    defaultMessage: 'Your password and password confirmation do not match'
                                });
                            }
                            return;
                        }
                    ]
                })), {
                    ref: passwordConfirmationInputRef,
                    secureTextEntry: true,
                    enterKeyHint: "done",
                    onSubmitEditing: function() {
                        return void request();
                    },
                    autoComplete: "new-password",
                    testID: "ResetPassword_passwordConfirmation"
                })),
                /*#__PURE__*/ _jsx(Button, {
                    onPress: request,
                    disabled: !data.password || !data.passwordConfirmation,
                    alignSelf: "center",
                    text: $t({
                        id: 'ResetPassword_submitButton',
                        defaultMessage: 'Set password'
                    }),
                    testID: "ResetPassword_submit"
                }),
                error ? /*#__PURE__*/ _jsxs(View, {
                    spacing: 10,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            text: $t({
                                id: 'ResetPassword_error',
                                defaultMessage: "We couldn't reset your password. Your token may have expired. Please request a new reset password email."
                            }),
                            color: theme.color.danger
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onPress: function() {
                                return navigation.navigate('RequestResetPassword', {});
                            },
                            style: {
                                marginLeft: 10
                            },
                            text: $t({
                                id: 'ResetPassword_requestNewEmailButton',
                                defaultMessage: 'Request another email'
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
}
